import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  paymentUrl:'',
  paymentData:{

  }
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_PAYMENT (state, isLoading){
    state.status.loading = isLoading
  },

  SET_PAYMENT_URL (state, data){
    state.paymentUrl = data
  },
  SET_PAYMENT_DATA (state, data){
    state.paymentData = data
  },
}

//async methods  store.dispatch('increment')
const actions = {

//for topup
  addPayment ({state, commit}, data) {

    commit('LOADING_PAYMENT', true);
    commit('SET_PAYMENT_URL', ''); //reset

    return api.post('payment', data)
      .then(function (response) {
        commit('SET_PAYMENT_URL', response.data.payment_url)

        commit('LOADING_PAYMENT', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_PAYMENT', false);
        commit('SET_PAYMENT_URL', '');
        return Promise.reject(error);

      });
  },

  loadPayment ({state, commit}, paymentId) {

    commit('LOADING_PAYMENT', true);
    commit('SET_PAYMENT_DATA', {}); //reset

    return api.get('transactionstemp/'+paymentId)
      .then(function (response) {
        commit('SET_PAYMENT_DATA', response.data.temptrx)

        commit('LOADING_PAYMENT', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_PAYMENT', false);
        commit('SET_PAYMENT_DATA', {});
        return Promise.reject(error);

      });
  },

    updatePayment ({state, commit}, query) {

      commit('LOADING_PAYMENT', true);
      commit('SET_PAYMENT_DATA', {}); //reset

      return api.post('payment/usertopupcallback', query)
        .then(function (response) {
          commit('SET_PAYMENT_DATA', response.data)

          commit('LOADING_PAYMENT', false);
          return Promise.resolve(response);
        })
        .catch(function (error) {
          commit('LOADING_PAYMENT', false);
          commit('SET_PAYMENT_DATA', {});
          return Promise.reject(error);

        });
    },
    //process payment data for cart order
    updateCartPayment ({state, commit}, query) {

      commit('LOADING_PAYMENT', true);
      commit('SET_PAYMENT_DATA', {}); //reset

      return api.post('payment/usercallback', query)
        .then(function (response) {

          commit('SET_PAYMENT_DATA', response.data)

          commit('LOADING_PAYMENT', false);
          return Promise.resolve(response);
        })
        .catch(function (error) {
          commit('LOADING_PAYMENT', false);
          commit('SET_PAYMENT_DATA', {});
          return Promise.reject(error);

        });
    },





}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/PaymentStore.js